import { render, staticRenderFns } from "./PropertyListingBackup2024.vue?vue&type=template&id=ec4509fe"
import script from "./PropertyListingBackup2024.vue?vue&type=script&lang=js"
export * from "./PropertyListingBackup2024.vue?vue&type=script&lang=js"
import style0 from "./PropertyListingBackup2024.vue?vue&type=style&index=0&id=ec4509fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports